import React from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <div className="container">
      <div className="landing-container">
        <div className="landing-header">
          <h1>Welcome to Ordease</h1>
          <p className="landing-subtitle">Streamline your order management process</p>
        </div>

        <div className="landing-options">
          <div className="landing-card">
            <h2>Join an Organization</h2>
            <p>Are you an employee looking to join your organization's order management system?</p>
            <Link to="/register" className="primary-button">
              Register as Employee
            </Link>
          </div>
          

          <div className="landing-card">
            <h2>Create an Organization</h2>
            <p>Are you a business owner looking to set up order management for your organization?</p>
            <Link to="/register-organization" className="primary-button">
              Register Organization
            </Link>
          </div>
        </div>

        <div className="landing-footer">
          <p>
            Already have an account?{' '}
            <Link to="/login" className="auth-link">
              Log in here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;